export default function TransfersService($http, appSettings) {
  'ngInject';
  var transferSRVs = {};

  const transfersEndpoint = appSettings.InReachApiTransfersEndpoint;

  transferSRVs.getKeysByFilter = function (filter) {
    return $http.get(`${transfersEndpoint}/keys?filter=${filter}`);
  };

  return transferSRVs;
}